import React from 'react'

import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, IconButton, Tooltip, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const TooltipContent = () => (
  <>
    <Box mb={1}>
      <Typography color="primary">Link a Shared Calendar</Typography>
    </Box>
    <Box pl={3}>
      <Typography
        component="li"
        variant="body2"
        color="textSecondary"
      >
        <strong>Share Scoir Visits</strong>
        &nbsp; &mdash; &nbsp; Visits created in Scoir can be shared to and visible in a linked Google or Microsoft
        calendar.
      </Typography>
      <Typography
        component="li"
        variant="body2"
        color="textSecondary"
      >
        <strong>Create a Unified View in Scoir</strong>
        &nbsp; &mdash; &nbsp; Display events from linked Google or Microsoft calendars in Scoir; toggle linked calendars
        as needed to manage a singBoxar view for planning visits and availabilty.
      </Typography>
    </Box>
  </>
)

export const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    padding: theme.spacing(1),
    backgroundColor: '#fff',
    border: `1px solid ${theme.palette.grey[200]}`,
  },
}))(Tooltip)

const HelpInfo = () => {
  return (
    <Box
      ml={1}
      color="text.secondary"
    >
      <HtmlTooltip
        placement="top"
        interactive
        title={<TooltipContent />}
      >
        <IconButton size="small">
          <Typography variant="srOnly">
            <TooltipContent />
          </Typography>
          <FontAwesomeIcon
            color="inherit"
            icon={faInfoCircle}
          />
        </IconButton>
      </HtmlTooltip>
    </Box>
  )
}

export default HelpInfo
